module.exports = __webpack_public_path__ + "static/media/HomeStoryLogo4.4ef16709.png";